import React, { FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';
import { Loader } from 'rs-emd-ui-atoms';
import { useCrmEmailPageQuery } from '../../generated/graphql';
import { RedirectWithStatus } from '../../rs-emd-ui-modules/src/helpers/redirect-with-status.component';

export const CRMEmailPageWrapper: FunctionComponent = () => {
  let location = useLocation();
  let token = new URLSearchParams(location.search).get('token');

  const { loading, error, data } = useCrmEmailPageQuery({
    variables: { token: token ?? '' },
    ssr: false,
    skip: !token?.length,
  });

  if (!token?.length) {
    return <RedirectWithStatus to={process.env.REACT_APP_ERROR_404_ENDPOINT} statusCode={404} />;
  }

  if (loading) {
    return <Loader />;
  } else if (error || !data) {
    return <RedirectWithStatus to={process.env.REACT_APP_ERROR_ENDPOINT} statusCode={500} />;
  } else if (!data.CRMEmailPage.isSuccess || !data.CRMEmailPage.html)
    return <RedirectWithStatus to={process.env.REACT_APP_ERROR_404_ENDPOINT} statusCode={404} />;

  return <div dangerouslySetInnerHTML={{ __html: data.CRMEmailPage.html }}></div>;
};

export default CRMEmailPageWrapper;
